/**
 * Static banner imports for routes that are not driven by {@link getCategoryAssets}
 * (Birthday page, Production detail routes). Event category + main Production/Blogs
 * use folder-based assets via categoryImageContexts.
 */

import birthdayBanner from "../assets/images/Social Event/Social Event/Birthday Party - 5 - 1080_1080.webp";
import prodDecoration from "../assets/images/Production/Production/Decoration - 5 - 1080_1080.webp";
import prodStageSetup from "../assets/images/Production/Production/Stage & Setup - 8 - 1080_1080.webp";
import prodCameraLive from "../assets/images/Production/Production/Camera & Live Streaming - 1 - 1080_1080.webp";
import prodPhotobooth from "../assets/images/Production/Production/Photobooth - 7 - 1080_1080.webp";
import prodCatering from "../assets/images/Production/Production/Catering - 8 - 1080_1080.webp";
import prodSoundAudio from "../assets/images/Production/Production/Sound & Audio - 1 - 1080_1080.webp";
import prodSpecialEffects from "../assets/images/Production/Production/Special Effects - 2 - 1080_1080.webp";
import prodArtist from "../assets/images/Production/Production/Artist & Celebrity Management - 8 - 1080_1080.webp";
import prodCreativeDesigning from "../assets/images/Production/Production/Creative Designing - 5 - 1080_1080.webp";
import prodBrandingPrint from "../assets/images/Production/Production/Branding And Print - 9 - 1080_1080.webp";

export const birthdayPageBanner = birthdayBanner;

/** Descriptive alt text for production sub-route banners (SEO / accessibility). */
export const productionRouteBannerAlts = {
  "decor-atelier": "Wedding and event décor — Panthi Events, Ahmedabad, Gujarat, India",
  "stall-design": "Exhibition stall design and branding — event management Gujarat",
  photography: "Professional event photography — weddings and corporate events Ahmedabad",
  "photo-booth": "Photo booth setup for weddings and parties — Gujarat, India",
  catering: "Event catering and banquet service — Ahmedabad, Gujarat",
  "av-equipments": "Professional sound system and AV equipment for concerts and corporate events",
  "special-effects": "Stage special effects — cold pyro and laser for live events India",
  "artist-management": "Artist and celebrity management for concerts — Gujarat event planner",
  "kids-zone": "Kids zone entertainment for birthday and family events Ahmedabad",
  "invitation-card": "Wedding invitation cards and event stationery — Panthi Events",
};

export const productionRouteBanners = {
  "decor-atelier": prodDecoration,
  "stall-design": prodStageSetup,
  photography: prodCameraLive,
  "photo-booth": prodPhotobooth,
  catering: prodCatering,
  "av-equipments": prodSoundAudio,
  "special-effects": prodSpecialEffects,
  "artist-management": prodArtist,
  "kids-zone": prodCreativeDesigning,
  "invitation-card": prodBrandingPrint,
};
